<template lang="pug">
div
  UiCardSection
    .ui-card-section-title {{ $t("companies.tabs.scope_vouchers") }}
  UiCardSection
    RestTable(
      namespace="scope_vouchers"
      :headers="headers"
      ref="scopeVouchersTable"
      :fetch-handler="getData"
      :initial-filters="initialFilters"
      embed
    )
      template(#filters="{ filters, updateFilters }")
        UiStack(align="end")
          UiStackItem(fill)
            UiFormGroup(:label="$t('companies.sales_invoices.status_filter')")
              UiMultiselect(
                :modelValue="filters.status"
                :options="statesOptions"
                label="text"
                @update:modelValue="updateFilters({ status: $event })"
              )
          UiStackItem(fill)
            UiFormGroup(:label="$t('companies.sales_invoices.search')")
              UiInput(
                :modelValue="filters.search"
                type="search"
                @update:modelValue="updateFilters({ search: $event })"
              )
          UiStackItem
            UiButton(
              variant="primary"
              @click="restartAll"
              icon="RefreshCw"
            ) {{ $t("companies.sales_invoices.actions.restart") }}
          UiStackItem
            UiButton(
              variant="danger"
              @click="deleteFailed"
              icon="Trash"
            ) {{ $t("companies.sales_invoices.actions.delete") }}
          UiStackItem
            UiButton(
              variant="warning"
              @click="deleteProcessed"
              icon="Trash"
            ) {{ $t("companies.sales_invoices.actions.delete_processed") }}
      template(#cell:status="{ item }")
        UiButton(
          :variant="STATUSES[item.status] || 'info'"
          :title="`Status reason: \"${item.status_reason}\"`"
        ) {{ $t(`companies.sales_invoices.statuses.${item.status}`) }}
      template(#cell:actions="{ item }")
        UiButton(
          size="sm"
          variant="smooth-danger"
          @click="deleteVoucher(item)"
          icon="Trash"
        ) {{ $t("actions.delete") }}
</template>

<script>
import ApiScopeVouchers from "@/api/scope_vouchers.js";

const STATUSES = {
  draft: "info",
  processing: "warning",
  processed: "success",
  failed: "danger",
};

export default {
  components: {},

  data() {
    return {
      initialFilters: {
        status: null,
        search: "",
      },
      states: [],
      STATUSES: STATUSES,
      headers: [
        {
          key: "id",
          label: "#",
          squeeze: true,
        },
        {
          key: "job_id",
          label: "Job id",
        },
        {
          key: "created_at",
          label: "Created at",
          squeeze: false,
        },
        {
          key: "invoice_number",
          label: "Voucher number",
          squeeze: false,
        },
        {
          key: "status",
          label: "Status",
          squeeze: false,
          sortable: true,
        },
        {
          key: "status_reason",
          label: "Status Reason",
          squeeze: false,
        },
        {
          key: "actions",
          label: "",
          squeeze: true,
        },
      ],
    };
  },

  computed: {
    statesOptions() {
      let first_element = { text: "All Invoices", value: null };
      let options = this.states.map((i) => {
        return { text: i[0], value: i[1] };
      });
      options.unshift(first_element);
      return options;
    },
  },

  methods: {
    reload() {
      this.$refs.scopeVouchersTable.fetchData();
    },

    getData(params, config) {
      return ApiScopeVouchers.fetchVouchers(
        this.$route.params.id,
        params,
        config,
      ).then((resp) => {
        return {
          items: resp.data.scope_vouchers,
          meta: resp.data.meta,
        };
      });
    },

    fetchStates() {
      ApiScopeVouchers.fetchStates(this.$route.params.id).then((resp) => {
        this.states = resp.data.states;
      });
    },
    restartAll() {
      ApiScopeVouchers.restartVouchers(this.$route.params.id).then((resp) => {
        this.reload();
      });
    },

    deleteFailed() {
      this.$dialogConfirm({
        title: this.$t("actions.remove"),
        description: this.$t("companies.sales_invoices.actions.confirm_delete"),
        variant: "danger",
        icon: "lan-disconnect",
        okLabel: this.$t("actions.remove"),
        okVariant: "danger",
        okIcon: "Trash",
        cancelVariant: "smooth-secondary",
      }).then((result) => {
        if (!result) return;
        ApiScopeVouchers.deleteFailedInvoices(this.$route.params.id).then(
          (resp) => {
            this.reload();
          },
        );
      });
    },

    deleteProcessed() {
      this.$dialogConfirm({
        title: this.$t("actions.remove"),
        description: this.$t("companies.sales_invoices.actions.confirm_delete"),
        variant: "danger",
        icon: "lan-disconnect",
        okLabel: this.$t("actions.remove"),
        okVariant: "danger",
        okIcon: "Trash",
        cancelVariant: "smooth-secondary",
      }).then((result) => {
        if (!result) return;
        ApiScopeVouchers.deleteProcessedInvoices(this.$route.params.id).then(
          (resp) => {
            this.reload();
          },
        );
      });
    },

    deleteVoucher(item) {
      this.$dialogConfirm({
        title: this.$t("actions.remove"),
        description: this.$t("actions.confirm_remove"),
        variant: "danger",
        icon: "lan-disconnect",
        okLabel: this.$t("actions.remove"),
        okVariant: "danger",
        okIcon: "Trash",
        cancelVariant: "smooth-secondary",
      }).then((result) => {
        if (!result) return;
        ApiScopeVouchers.deleteVoucher(this.$route.params.id, item.id).then(
          (resp) => {
            this.reload();
          },
        );
      });
    },
  },

  created() {
    this.fetchStates();
  },
};
</script>
